// THE HEALTH LINES, defined once and read by both sides of the wire (D-612
// ruling 1). The server's rules judge a tenant's dot against them, and the
// console colours its strip cells on the same lines, so a cell and the dot
// cannot disagree about one number. A zero-import module with its own package
// export (`@assessly/contracts/platform/health-lines`), on the pattern of
// `files/limits`: the console needs four numbers, not the contracts index.
//
// The console's reason copy spells these numbers out in six languages
// ("1% or more", "2 s or more", "a minute or more", "15 minutes"). A web test
// holds that copy to these values, so moving a line fails until the copy
// moves with it.

export const HEALTH_LINES = {
  /** Error rate at or above this (basis points) turns the dot amber: 1%. */
  amberErrorRateBp: 100,
  /** p95 latency at or above this turns the dot amber: 2 s. */
  amberP95Ms: 2000,
  /** Event lag at or above this turns the dot amber: one minute. */
  amberLagSeconds: 60,
  /** Event lag above this, held for 15 minutes, opens `queue_lag`. */
  lagAlertSeconds: 300,
  /** A board with no window this recent reads grey: 15 minutes. */
  staleAfterSeconds: 15 * 60,
} as const;
